export class PageTitle {
	constructor(
		public readonly main: string,
		public readonly secondary: string,
	) {}
}
